import type { LoadStatus, Session } from '../domain/session.model';

/**
 * Redux state for the account "Sessions" tab: the active sessions, the load
 * lifecycle, and which session (if any) is currently being revoked (drives the
 * per-row spinner). Every field serialisable.
 */
export interface SecuritySessionsState {
  sessions: Session[];
  loadStatus: LoadStatus;
  /** The id of the session whose revoke is in flight, or null. */
  revokingId: string | null;
}

export const initialState: SecuritySessionsState = {
  sessions: [],
  loadStatus: 'idle',
  revokingId: null,
};
